import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html'
})
export class NotAuthorized implements OnInit {

  message: string = "You are not authorized to view this page!";

  constructor() { }

  ngOnInit() {
  }

}
